import { ModalPrivacyComponent as PrivacyComponent } from "./privacy/modal-privacy.component";
import { ModalThirdPartyComponent as ThirdPartyComponent } from "./thirdParty/modal-thirdParty.component";
import { ModalLeaveComponent as LeaveComponent } from "./leave/modal-leave.component";

export { PrivacyComponent, ThirdPartyComponent, LeaveComponent };



// WEBPACK FOOTER //
// ./src/app/modal/index.ts